import { React, useState, useEffect, useCallback, useContext } from "react";
import Button from "@mui/material/Button";
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import GridNoRow from '../../../../common/GridNoRow';
import axios from "axios";
import Swal from "sweetalert2";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import DeptRegModal from "../../../../modal/PC/gijun/DeptRegModal";
import DeptUpdateModal from "../../../../modal/PC/gijun/DeptUpdateModal";
import styled from "styled-components";
import Select from 'react-select';
import { AppContext } from '../../../../AppStore';
import Moment from 'moment';
import "moment/locale/ko";
import { useNavigate, useLocation } from "react-router-dom";

const Dept = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [originRows, setOriginRows] = useState([]);
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [keyword, setKeyword] = useState({
        dept_search_name: '',
    });
    const [isRegModalOpen, setRegModalOpen] = useState(false);
    const [isUpdateModalOpen, setUpdateModalOpen] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [selectDeptID, setSelectDeptID] = useState('');
    const [deptModalFullOption, setDeptModalFullOption] = useState([]);
    const [deptModalOption, setDeptModalOption] = useState([]);
    const [zeroMaxSort, setZeroMaxSort] = useState(0);

    // Grid정의
    const handleSetting = () => {
        setColumns([
            (MenuUpdateExistYN === "Y"?
                {
                    field: 'updated',
                    headerName: '수정',
                    width: 55,
                    type:'actions',
                    disableClickEventBubbling: true,
                    getActions: (params) => [
                        <GridActionsCellItem icon={<EditIcon color="primary" />} onClick={() => {UpdateClick(params)}} label="Edit" />
                    ],
                    headerAlign: 'center', 
                    align:'center'
                } : {}),
            (MenuDeleteExistYN === "Y"?
                {
                    field: 'deleted',
                    headerName: '삭제',
                    width: 55,
                    type:'actions',
                    disableClickEventBubbling: true,
                    getActions: (params) => [
                        <GridActionsCellItem icon={<DeleteIcon color={ MenuDeleteYN === "Y" && params.row.update_flag === 'Y' ? "error" : "grey"} />} onClick={() => {DeleteClick(params)}} label="Delete" disabled={ MenuDeleteYN === "Y" && params.row.update_flag === 'Y'? false : true } />
                    ],
                    headerAlign: 'center', 
                    align:'center'
                } : {}),
            { field: 'id', headerName: '부서ID', width: 0, headerAlign: 'center', align:'center' },
            { field: 'dept_name', headerName: '부서명', width: 200, headerAlign: 'center', align:'left' },
            { field: 'upper_dept_id', headerName: '상위부서ID', width: 0, headerAlign: 'center', align:'center' },
            { field: 'upper_dept_name', headerName: '상위부서명', width: 200, headerAlign: 'center', align:'left' },
            { field: 'dept_sort', headerName: '정렬순서', width: 100, headerAlign: 'center', align:'right' },
            { field: 'reg_user_id', headerName: 'reg_user_id', width: 0, headerAlign: 'center' },
            { field: 'reg_user_name', headerName: '등록자', width: 120, headerAlign: 'center', align:'center' },
            { field: 'reg_datetime', headerName: '등록일시', width: 180, headerAlign: 'center', align:'center' },
            { field: 'update_user_id', headerName: 'update_user_id', width: 0, headerAlign: 'center' },
            { field: 'update_user_name', headerName: '수정자', width: 120, headerAlign: 'center', align:'center' },
            { field: 'update_datetime', headerName: '수정일시', width: 180, headerAlign: 'center', align:'center' },
        ]);
    }

    const [columnVisibilityModel, setColumnVisibilityModel] = useState({
        id: false,
        dept_name: true,
        upper_dept_id: false,
        upper_dept_name: true,
        dept_sort: true,
        reg_user_id: false,
        reg_user_name: true,
        reg_datetime: true,
        update_user_id: false,
        update_user_name: true,
        update_datetime: true,
        deleted: true,
        updated: true
    });

    useEffect(() => {
        const accessList = JSON.parse(localStorage.getItem("nav"));
        
        if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
            setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
            setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
            setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
            setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
            setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
            setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
        }else{
            Swal.fire({
                title: '<p style="color:red">접근 권한 오류</p>',
                text: '화면에 접근 권한이 없습니다.',
                confirmButtonText: '확인',
                confirmButtonColor: '#7066e0',
                timer:5000,
                timerProgressBar: true
            }).then((value) => {
                return navigate(-1);
            });
        }
    }, []);

    useEffect(() => {
        // 아래의 변수가 변경되면 실행된다. -> 권한체크가 되면 MenuID가 변경되므로, 권한체크 후 Grid 설정.
        if(String(MenuID) !== String(0) && MenuID != null){
            handleSetting();
            handleInit();
            handleView();
        }
    }, [MenuID]);

    // Grid 데이터 조회
    const handleView = () => {
        if (appStore.loading) return;
        appStore.setLoading(true);
        
        axios.get('/api/p/Dept/List',
            {
            params : {
                dept_search_name: keyword.dept_search_name,
            }
          },
          { withCredentials: true }
        )
        .then((response) => {
            const PermissionMap = {};
            response.data.forEach(row => {
                if (!PermissionMap[row.dept_id]) {
                    PermissionMap[row.dept_id] = [row.reg_user_id, row.update_user_id].includes(Number(localStorage.getItem('user_id')));
                }
            });

            const array = response.data.map((item, index) => ({
                id: item.dept_id,
                dept_name: item.dept_name,
                upper_dept_id: item.upper_dept_id,
                upper_dept_name: item.upper_dept_name,
                dept_sort: item.dept_sort,
                reg_user_id: item.reg_user_id,
                reg_user_name: item.reg_user_name,
                reg_datetime: (item.reg_datetime === undefined?'':Moment(item.reg_datetime).format('YYYY-MM-DD HH:mm:ss')),
                update_user_id: item.update_user_id,
                update_user_name: item.update_user_name,
                update_datetime: (item.update_datetime === undefined?'':Moment(item.update_datetime).format('YYYY-MM-DD HH:mm:ss')),
                update_flag: PermissionMap[item.dept_id] ? 'Y' : 'N'
            }));
            setOriginRows(response.data);
            setRows(array);

            // 같은 dept 정보는 이곳에서 같이 생성
            const modal_full_array = response.data.map((item, index) => ({
                id: item.dept_id,
                dept_name: item.dept_name,
                upper_dept_id: item.upper_dept_id,
                upper_dept_name: item.upper_dept_name,
                dept_sort: item.dept_sort,
            }));
            const modal_select_array = response.data.map((item, index) => ({
                value: item.dept_id, label: item.dept_name, maxsort: item.max_sort
            }));

            let zero_max_sort = 1;
            response.data.map((item,index) =>{
                if(item.upper_dept_id == 0){
                    zero_max_sort++
                }
            })
            setZeroMaxSort(zero_max_sort)
            
            modal_select_array.unshift({ value: 0, label : '상위부서', maxsort:zero_max_sort});
            setDeptModalFullOption(modal_full_array);
            setDeptModalOption(modal_select_array);
        })
        .catch((error) => {
            appStore.capture();
        })
        .finally(() => {
            appStore.setLoading(false);
        });

    };

    const handleInit = () => {
        setKeyword({
            dept_search_name: '',
        })
        
        // Hide컬럼 숨기기.
        setColumnVisibilityModel({
            id: false,
            dept_name: true,
            upper_dept_id: false,
            upper_dept_name: true,
            dept_sort: true,
            reg_user_id: false,
            reg_user_name: true,
            reg_datetime: true,
            update_user_id: false,
            update_user_name: true,
            update_datetime: true,
            deleted: true,
            updated: true,
            update_flag: false
        });
    };

    const handleReg = () => {
        setRegModalOpen(true);
        setModalTitle('부서 등록');
    };

    const UpdateClick = (object) => {
        setUpdateModalOpen(true);
        setModalTitle('부서 수정');
        setSelectDeptID(object.row.id);
    };

    const DeleteClick =(object) => {
        Swal.fire({
            title: '부서 '+object.row.dept_name+' 삭제',
            html : '부서 '+object.row.dept_name+'을(를) <span style="color:red; font-weight:bold;">삭제</span> 하시겠습니까?<br/>삭제하시면 복구 할 수 없습니다.',
            showCancelButton : true,
            confirmButtonColor : "#d33",
            confirmButtonText : "삭제",
            cancelButtonText : "닫기"
        }).then((result) => {
            if (result.isConfirmed) {
                if (appStore.loading) return;
                appStore.setLoading(true);

                axios.post('/api/p/Dept/Delete', new URLSearchParams({
                    delete_dept_id: object.row.id
                }),
                { withCredentials: true })
                .then(function (response) {
                    if(response.status === 200){
                        Swal.fire({
                            title: '부서 '+object.row.dept_name+' 삭제 완료',
                            text: '정상적으로 부서 '+object.row.dept_name+'가 삭제 되었습니다.',
                            confirmButtonText: '확인',
                            timer: 5000,
                            timerProgressBar: true
                        }).then((result) => {
                            setRows((rows) => rows.filter((data) => data.id !== object.row.id));
                        });
                    }else{
                        appStore.capture();
                    }
                })
                .catch(function (error) {
                    appStore.capture();
                })
                .finally(() => {
                    appStore.setLoading(false);
                });
            }
        });
    };

    const onChange = (e)=>{
        const {name, value} = e.target;
        const nextKeyword = {
            ...keyword,
            [name]: value, 
        };
        setKeyword(nextKeyword);
    };
    
    const onSubmitSearch = (e) => {
        //입력 검색어는 Enter로 조회.
        if (e.key === "Enter") {
          handleView();
        }
    };

    const handleRegSuccessSave = (regID) => {
        setModalTitle('부서 수정');
        setRegModalOpen(false);
        handleView();

        Swal.fire({
            title: '부서 등록 완료',
            text: '정상적으로 부서가 등록 되었습니다.',
            confirmButtonText: '확인',
            timer: 5000,
            timerProgressBar: true
        }).then((result) => {
            // 수정 화면 불러오기
            setUpdateModalOpen(true);
            setSelectDeptID(Number(regID));
        });
    };

    const handleExcel = () => {
        var filename = '부서관리'
        axios.get('/api/p/Dept/Excel',
        {   
            params : { dept_search_name: keyword.dept_search_name, file_name: filename },
            responseType:'blob'
        },
        { withCredentials: true })
        .then(function (response) {
            
            if(response.status === 200){
                filename = filename + ' ' + appStore.YYYY_MM_DD_HH_MI_SS();
                const link = document.createElement('a');
                link.href = URL.createObjectURL(response.data);
                link.setAttribute('download', filename+'.xlsx');
                document.body.appendChild(link);
                link.click();
            }
        })
        .catch(function (error) {
            appStore.capture();
        })
    };

    return (
        <div style={ { width:'100%', display: String(MenuID) === String(0) ? 'hidden' : 'block' } }>
            <div className="menubox">
                <div className="menu-action">
                    <div className="menu-title">{ MenuName }</div>
                        <div className="menu-button">
                        { MenuUpdateYN === "Y"?
                        <Button 
                            onClick={ handleReg }
                            className="btn-p btn-u"
                            sx={{  
                                m: 1, 
                                fontSize: 15, 
                                color: "white", 
                                borderColor: "#FF3636", 
                                backgroundColor: "#FF3636",
                                ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                            }} 
                            variant="outlined">
                            등록
                        </Button> : "" }
                        {isRegModalOpen  && MenuUpdateYN === 'Y' && (
                            <DeptRegModal
                            onClose={() => {
                                setRegModalOpen(false);
                            }}
                            title={modalTitle}
                            handleRegSuccessSave={handleRegSuccessSave}
                            deptModalFullOption={deptModalFullOption}
                            deptModalOption={deptModalOption}
                            zero_max_sort = {zeroMaxSort}
                            MenuUpdateYN={MenuUpdateYN}
                            />
                        )}
                        <Button 
                            onClick={ handleExcel }
                            className="btn-p"
                            sx={{  
                                m: 1, 
                                fontSize: 15, 
                                color: "white", 
                                borderColor: "#00AC47", 
                                backgroundColor: "#00AC47",
                                ":hover": { boxShadow: "2px 2px 2px #00AC47" , backgroundColor: "#00AC47", borderColor: "#00AC47"}
                            }} 
                            variant="outlined">
                            엑셀
                        </Button>
                        <Button 
                            onClick={ handleInit }
                            className="btn-p"
                            sx={{  
                                m: 1, 
                                fontSize: 15, 
                                color: "white", 
                                borderColor: "black", 
                                backgroundColor: "black",
                                ":hover": { boxShadow: "2px 2px 2px black" , backgroundColor: "black", borderColor: "black"}
                            }} 
                            variant="outlined">
                            초기화
                        </Button>
                        <Button 
                            onClick={ handleView }
                            className="btn-p"
                            sx={{  
                                m: 1, 
                                fontSize: 15, 
                                color: "white", 
                                borderColor: "#3D63AE", 
                                backgroundColor: "#3D63AE",
                                ":hover": { boxShadow: "2px 2px 2px #3D63AE" , backgroundColor: "#3D63AE", borderColor: "#3D63AE"}
                            }} 
                            variant="outlined">
                            조회
                        </Button>
                    </div>
                </div>
                <div className="menu-keyword">
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-title">
                            부서명
                        </div>
                        <div className="menu-keyword-sub-keyword">
                            <input type="text" placeholder="부서명" value={keyword.dept_search_name} name="dept_search_name" onChange={(e) => onChange(e) } onKeyPress={onSubmitSearch} autoComplete="off" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="grid">
                <div className="grid_sub" style={ { width: '100%', fontSize: '17px' } }>
                    <DataGrid
                        className="grid_main"
                        rows={rows}
                        columns={columns}
                        slots={{
                            noRowsOverlay: GridNoRow,
                        }}
                        columnVisibilityModel={columnVisibilityModel}
                        AlternatingRowBackground="LavenderBlush"
                        rowsPerPageOptions={[20, 50, 100]}
                    />
                    {isUpdateModalOpen && (
                        <DeptUpdateModal
                        onClose={() => {
                            setUpdateModalOpen(false);
                        }}
                        title={modalTitle}
                        id={selectDeptID}
                        originRows={originRows.filter(row => String(row.dept_id) === String(selectDeptID))}
                        handleView={handleView}
                        deptModalFullOption={deptModalFullOption}
                        deptModalOption={deptModalOption}
                        MenuUpdateYN={MenuUpdateYN}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}

const AppWrap = styled.div`
  text-align: center;
  margin: 50px auto;
`;

export default Dept;
